import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import type { BillingCycle } from '@interfaces/billingCycle';
import { useLocalization } from '@utils/useLocalization';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';

const FETCH_BILLING_CYCLE_BREADCRUMB = gql`
  query fetchBillingCycleBreadcrumb($billingCycleId: ObjectID!) {
    fetchBillingCycle(billingCycleId: $billingCycleId) {
      billingCycle {
        organization { id translatedName { ${TRANSLATED_STRING_FIELDS} } }
        startDate
        endDate
      }
    }
  }
`;

export const FeeReportBreadcrumb = () => {
  const { localizedDate } = useLocalization();

  const { data } = useQuery(FETCH_BILLING_CYCLE_BREADCRUMB, {
    variables: { billingCycleId: useParams().billingCycleId },
  });
  const billingCycle: BillingCycle | undefined =
    data?.fetchBillingCycle?.billingCycle;
  if (!billingCycle) return '';

  return `${translateBackend(billingCycle.organization?.translatedName)} ${
    billingCycle?.startDate && billingCycle?.endDate
      ? `(${localizedDate(billingCycle.startDate)} - ${localizedDate(dayjs(billingCycle.endDate).subtract(1, 'day'))})`
      : ''
  }`;
};
